<template>
  <div>
    <div class="page-loader" v-show="pageLoading">
      <div>
        <PageLoader />
      </div>
    </div>

    <div v-show="!pageLoading">
      <div>
        <div>
          <div class="data-fetch-error" v-show="dataFetchError">
            <p>Unable to fetch data. Please try again.</p>
          </div>
        </div>

        <div class="row profile-header small-screen-header">
          <div class="col-md-8">
            <div class="text-right">
              <a @click.prevent="edit()" class="edit" v-if="!editing">
                <font-awesome-icon icon="edit" />edit
              </a>
              <a @click.prevent="closeEdit()" class="edit" v-else>
                <font-awesome-icon icon="times" />close edit
              </a>
            </div>

            <div class="d-flex justify-content-center top-section">
              <div class="d-flex flex-column justify-content-center profile-info">
                <div class="card img-container">
                  <img
                    class="card-img-top"
                    src="./../../../assets/style/images/boy.svg"
                    alt="Avatar"
                  />
                </div>

                <h2 class="page-title">{{user.firstname}} {{user.lastname}}</h2>
              </div>
            </div>
            <!-- row end -->
          </div>
        </div>
      </div>
      <!-- row end -->

      <div class="row profile-header big-screen-header">
        <div class="col-md-8">
          <div class="d-flex justify-content-between align-items-center top-section">
            <div class="d-flex align-items-center profile-info">
              <div class="card img-container">
                <img class="card-img-top" src="./../../../assets/style/images/boy.svg" alt="Avatar" />
              </div>

              <h2 class="page-title">{{user.firstname}} {{user.lastname}}</h2>
            </div>

            <a @click.prevent="edit()" class="edit" v-if="!editing">
              <font-awesome-icon icon="edit" />Edit
            </a>
            <a @click.prevent="closeEdit()" class="edit" v-else>
              <font-awesome-icon icon="times" />close edit
            </a>
          </div>
        </div>
      </div>
      <!-- row end -->

      <div class="row page-body">
        <div class="col-md-8">
          <div class="multiple-entry-form">
            <h5>Personal</h5>

            <div>
              <div class="d-flex info-block">
                <div class="key">Gender:</div>
                <div class="value" v-if="!editing">{{ user.gender ? user.gender : '--'}}</div>
                <div class="value" v-else>
                  <div class="custom-select__input">
                    <select class="form-control" v-model.trim="user.gender">
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                    <div>
                      <font-awesome-icon icon="angle-down" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex info-block">
                <div class="key">Email:</div>
                <div class="value" v-if="!editing">{{user.email}}</div>
                <div class="value" v-else>
                  <input type="email" class="form-control" disabled v-model.trim="user.email" />
                </div>
              </div>

              <div class="d-flex info-block">
                <div class="key">Birthday:</div>
                <div class="value" v-if="!editing">{{user.date_of_birth ? user.date_of_birth : '--'}}</div>
                <div class="value" v-else>
                  <input
                    class="form-control"
                    type="date"
                    placeholder="yyyy-mm-dd"
                    v-model="employee.date_of_birth"
                  />
                </div>
              </div>

              <div class="d-flex info-block">
                <div class="key">Phone:</div>
                <div class="value" v-if="!editing">{{user.phone ? user.phone : '--'}}</div>
                <div class="value" v-else>
                  <input class="form-control" type="text" v-model="user.phone" />
                </div>
              </div>

              <div class="d-flex info-block">
                <div class="key">Alternate Phone Number</div>
                <div class="value" v-if="!editing">{{employee.alternate_phone_number ? employee.alternate_phone_number : '--'}}</div>
                <div class="value" v-else>
                  <input type="text" class="form-control" v-model="employee.alternate_phone_number" />
                </div>
              </div>

              <div class="d-flex info-block">
                <div class="key">Emergency Contact</div>
                <div class="value" v-if="!editing">
                  <p>Name: {{ employee.next_of_kin ? employee.next_of_kin : '--'}}</p>
                  <p>Phone: {{employee.kin_phone ? employee.kin_phone : '--'}}</p>
                  <p>Relationship: {{employee.kin_relationship ? employee.kin_relationship : '--'}}</p>
                </div>

                <div class="value" v-else>
                  <div class="emergency-contact">
                    <input type="text" class="form-control" placeholder="Name" v-model.trim="employee.next_of_kin" />

                    <input type="text" class="form-control" placeholder="Phone" v-model.trim="employee.kin_phone" />

                    <input
                      type="text"
                      class="form-control"
                      placeholder="Relationship"
                      v-model.trim="employee.kin_relationship"
                    />
                  </div>
                </div>
              </div>

              <div class="d-flex info-block">
                <div class="key">Home Address</div>
                <div class="value" v-if="!editing">
                  <p>{{user.address ? user.address == 'null' ? '--' : user.address : '--'}}</p>
                </div>

                <div class="value" v-else>
                  <textarea class="form-control" rows="3" v-model.trim="user.address"></textarea>
                </div>
              </div>

              <div>
                <div class="error" v-if="editing">
                  <p v-if="dataSaveError">{{dataSaveError}}</p>
                  <div v-if="serverErrors">
                    <p v-for="(value, name, index) in serverErrors" :key="index">{{value[0]}}</p>
                  </div>

                  <div v-if="emptyFields">
                    <p
                      v-for="(field, index) in emptyFields"
                      :key="index"
                    >The {{field}} input is required.</p>
                  </div>
                </div>
              </div>

              <div class="success" v-if="editing">
                <p v-if="dataSaveSuccess">{{dataSaveSuccess}}</p>
              </div>

              <div v-if="editing">
                <div class="submit-container">
                  <div class="button d-flex align-items-center">
                    <a @click.prevent="saveProfile()" v-show="!loading">Save & Submit</a>
                    <WhiteLoader v-show="loading" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
        
        </div>
      </div>
      <!-- row1 end -->
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";
import PageLoader from "../../partials/page-loader";

export default {
  name: "PersonalDetails",

  components: {
    WhiteLoader,
    PageLoader
  },

  data() {
    return {
      item: "personal-details",
      employee: {},
      user: {},

      editing: false,
      loading: false,

      emptyFields: [],
      serverErrors: [],
      pageLoading: true,

      dataSaveError: "",

      dataFetchError: false,
      dataSaveSuccess: "",
    };
  },

  created() {
    this.getEmployee();
  },

  mounted() {
    document.getElementById("offCanvas").checked = false;
  },

  methods: {
    getEmployee() {
      this.$http
        .get(types.GET_EMPLOYEE_API)
        .then(resp => {
          const data = resp.data.data;
          this.employee = data;
          this.user = data.user;
          this.pageLoading = false;
        })
        .catch(err => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    gender(gender) {
      if (!gender) return "";
      if (gender == "null") return "";
      return gender;
    },

    edit() {
      this.editing = true;
    },
    closeEdit() {
      this.editing = false;
    },

    updateData() {
      return {
        gender: this.user.gender,
        date_of_birth: this.employee.date_of_birth,
        phone: this.user.phone,
        alternate_phone: this.employee.alternate_phone_number,
        kin_info: {
          next_of_kin: this.employee.next_of_kin,
          kin_relationship: this.employee.kin_relationship,
          kin_phone: this.employee.kin_phone
        },
        address: this.user.address,
      };
    },

    saveProfile() {
      this.serverErrors = null;
      this.dataSaveError = "";
      this.dataSaveSuccess = "";

      if (!this.user.phone) {
        this.dataSaveError = "The phone field is required.";
        return;
      }

      if (!this.user.address) {
        this.dataSaveError = "The address field is required.";
        return;
      }

      if (!this.user.phone.match(/^[0-9]+$/)) {
        this.dataSaveError = "The phone field should be numbers only";
        return;
      }

      let updateData = this.updateData();

      this.loading = true;
      this.$http
        .put(types.UPDATE_EMPLOYEE_PERSONAL_INFORMATION, updateData)
        .then(resp => {
          this.loading = false;
          this.editing = false;
          this.dataSaveSuccess = resp.data.message;
          this.getEmployee();
        })
        .catch(err => {
          this.loading = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.error {
  margin-top: 10px;
  text-align: center;
  color: red;
  font-size: 0.938vw;
  font-style: italic;
  p {
    margin: 0;
  }
  > div {
    padding-bottom: 25px;
  }
}

.success {
  margin-top: 10px;
  color: green;
  font-size: 0.938vw;
  font-style: italic;
  p {
    margin-bottom: 0;
    text-align: center;
  }
}

.data-fetch-error {
  margin-top: 10px;
  text-align: center;
  color: red;
  font-size: 0.938vw;
  font-style: italic;
  p {
    margin: 0;
    padding-bottom: 10px;
  }
  p::first-letter {
    text-transform: uppercase;
  }
}

.page-loader {
  margin-top: 50px;

  > div {
    width: 55px;
    margin: auto;
  }
}

.page-body {
  margin: auto;

  .info-block {
    padding-bottom: 40px;
  }

  .value {
    width: 60%;
    color: #5099de;
    font-size: 14px;
    font-family: Nunito;
    line-height: 1.19;
    color: #000000;
  }
  .key {
    width: 40%;
    font-size: 14px;
    font-weight: 200;
    line-height: 1.67;
    color: #000000;
    font-family: Nunito;
    font-size: 14px;
    letter-spacing: normal;
    color: #707070;
  }
}

.small-screen-header {
  display: none;
}

.container {
  > div {
    padding-bottom: 40px;
    padding-left: 3.125vw;
    padding-right: 3.125vw;

    .profile-header {
      margin: 40px auto;
    }

    .fun-facts {
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #f8fcfe;
      margin-bottom: 40px;
    }
    .fun-facts h5 {
      font-family: Nunito;
      font-size: 18px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.22;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }
    .fun-facts p {
      font-family: Nunito;
      font-size: 12px;
      font-weight: 200;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }
    .fun-facts img {
      height: 50px;
    }
    .fun-facts .button {
      height: 41px;
      border-radius: 5px;
      background-color: #5099de;
      margin: auto;
    }
    .fun-facts .card {
      padding: 40px;
    }

    .fun-facts a {
      height: 20px;
      font-family: Nunito;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.21;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
    }
  }
}

input,
input:focus {
  outline: none;
}
.form-control {
  box-shadow: none !important;
  border-radius: 0;
  border: solid 1px #c7c7c7;
  background-color: #ffffff;
}

.form-control:not(textarea) {
  height: 35px;
}

.profile-header h2 {
  font-family: Nunito;
  font-size: 28px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.16;
  letter-spacing: normal;
  color: #000000;
  margin-bottom: 0;
  text-transform: capitalize;
}

.profile-info {
  width: 60%;
}

.img-container {
  border-radius: 50%;
  height: 100px;
  padding: 20px;
  width: 132px;
  background-color: #ffe7bd;
  margin-right: 20px;
}

.img-container img {
  height: 58px;
}

.top-section {
  padding-left: 0px;
  padding-right: 0px;
}
.top-section {
  a {
    width: auto;
    font-family: Nunito;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.88;
    letter-spacing: 0.48px;
    color: #f3826c;
    cursor: pointer;
  }
  a:hover {
    color: #f3826c;
  }
}

.multiple-entry-form {
  border-radius: 2px;
  padding: 4vw;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;

  > h5 {
    margin-bottom: 50px;
    font-family: Nunito;
    font-size: 18px;
    color: #5099de;
  }

  .emergency-contact {
    border: solid 1px #c7c7c7;
  }
  .emergency-contact .form-control {
    border: none !important;
  }

  .submit-container {
    margin-top: 50px;
  }
  .submit-container a {
    height: 20px;
    font-family: Nunito;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
  .submit-container a:hover {
    color: #ffffff;
  }
  .submit-container .button {
    width: 174px;
    height: 41px;
    border-radius: 5px;
    background-color: #5099de;
    cursor: pointer;
  }

  .custom-select__input {
    border-radius: 1px;
    border-radius: 0;
    height: 35px;
    border: solid 1px #c7c7c7;
    background-color: #ffffff;
    overflow: hidden;
    position: relative;
  }

  .custom-select__input > div {
    position: absolute;
    color: #777777;
    top: 0;
    right: 0;
    width: 30px;
    height: 100%;
    text-align: center;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    align-content: center;
  }

  .custom-select__input > select {
    height: 35px;
    border: solid 1px #c7c7c7;
    background-color: transparent;
    border: 0;
    outline: 0;
    padding: 0 10px;
    text-align: left;
    -moz-appearance: none;
    -webkit-appearance: none;
    position: relative;
    z-index: 2;
    font-size: 16px;
    line-height: 1.67;
    color: #777777;
  }

  .custom-select__input > select::-ms-expand {
    display: none;
  }
}

.page-loader {
  margin-top: 50px;
}
.page-loader > div {
  width: 55px;
  margin: auto;
}

.page-title {
  font-weight: 500;
}

@media (min-width: 768px) {
  .page-title h1 {
    margin-bottom: 0;
    margin-top: 10px;
    text-align: left;
  }
}

@media (min-width: 992px) {
  .page-title h1 {
    margin-left: 120px;
  }
}

@media (min-width: 768px) {
  .page-title h1 {
    padding-top: 20px;
  }
}

.ty {
  font-weight: 600;
}

@media (max-width: 760px) {
  .container {
    > div {
      padding: 0;
    }
  }
}

@media (max-width: 767px) {
  .fun-facts {
    margin-top: 20px;
  }
  .submit-container {
    display: flex;
    justify-content: center;
  }

  .small-screen-header {
    display: block;

    .profile-info {
      width: auto;

      .img-container {
        margin-right: 0;
        margin: 30px 0 20px 0;
        width: 102px;
      }

      h2 {
        text-align: center;
      }
    }

    a {
      width: auto;
      font-family: Nunito;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.88;
      letter-spacing: 0.48px;
      color: #f3826c;
      cursor: pointer;
    }

    a :hover {
      color: #f3826c;
    }
  }

  .big-screen-header {
    display: none;
  }
}
</style>
